module.exports = __webpack_public_path__ + "images/User.3e757f4d1f40c7261d8abfbace6fd85a.svg";